import { createAction, props } from '@ngrx/store';
import {
  ExceptionQueryParams,
  ExceptionRecord,
  ExceptionTraceStep,
} from '../../services/device.service';

// ── Stream ───────────────────────────────────────────────────────────────────

export const streamExceptions = createAction(
  '[Exceptions] Stream',
  props<{ params: ExceptionQueryParams; preserveExisting?: boolean }>()
);

export const streamInit = createAction(
  '[Exceptions] Stream Init',
  props<{ total_services: number }>()
);

export const streamChunk = createAction(
  '[Exceptions] Stream Chunk',
  props<{ exceptions: ExceptionRecord[] }>()
);

export const streamComplete = createAction(
  '[Exceptions] Stream Complete',
  props<{ total_count: number; services_queried: string[]; services_failed: string[] }>()
);

export const streamError = createAction(
  '[Exceptions] Stream Error',
  props<{ error: string }>()
);

/** Cancel the in-flight SSE stream without starting a new one. */
export const streamCancel = createAction('[Exceptions] Stream Cancel');

/** Reset all exceptions state back to initial. */
export const streamClear = createAction('[Exceptions] Stream Clear');

/** Reset the started flag without clearing exception data (e.g. when reverting custom date range). */
export const startedReset = createAction('[Exceptions] Started Reset');

// ── Trace ────────────────────────────────────────────────────────────────────

export const loadTrace = createAction(
  '[Exceptions] Load Trace',
  props<{ operationId: string; environment: string; excTimestamp?: string }>()
);

export const loadTraceSuccess = createAction(
  '[Exceptions] Load Trace Success',
  props<{ operationId: string; steps: ExceptionTraceStep[] }>()
);

export const loadTraceFailure = createAction(
  '[Exceptions] Load Trace Failure',
  props<{ operationId: string; error: string }>()
);
